<template>
  <section class="px-4.5 py-10 md:bg-card md:py-12">
    <div class="mx-auto max-w-content-container">
      <h2 class="mb-6 text-h3 md:mb-10">
        Gain market knowledge and connect with Lithium experts:
      </h2>
      <ul class="mx-auto flex gap-x-5 md:w-1/2 md:min-w-[41.25rem]">
        <li class="w-full gap-3 md:flex">
          <div class="mb-3.5 size-7 shrink-0">
            <CommonIcon class="size-full text-p-900" name="calendar-date" />
          </div>
          <p class="text-paragraph-sm md:text-h5">
            Engage with our regular webinars and global events programme
          </p>
        </li>

        <li class="w-full gap-3 md:flex">
          <div class="mb-3.5 size-7 shrink-0">
            <CommonIcon class="size-full text-p-900" name="server-06" />
          </div>
          <p class="text-paragraph-sm md:text-h5">
            Follow Benchmark Lithium on
            <a
              class="text-semantic-neutral"
              href="https://www.linkedin.com/showcase/106554721"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
            </a>
            for dedicated market insights and pricing data
          </p>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import CommonIcon from '~/components/common/Icon.vue'
</script>
